import ItemTypeDetailModalContainer from "@features/dashboard/containers/ItemTypeDetailModalContainer";
import { useAdaptiveSessionStart } from "@features/dashboard/hooks/useAdaptiveSessionStart";
import { useLanguageLearningProgress } from "@features/dashboard/hooks/useLanguageLearningProgress";
import { handleNavigateBack } from "@helpers/common";
import Box from "@memorang/ui/components/Box";
import { CustomAppBar } from "@memorang/ui/components/CustomAppbar";
import EmptyState from "@memorang/ui/components/EmptyView";
import { MicrophonePermissionDialog } from "@memorang/ui/components/MicroPhonePermissionDialog";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";
import { ItemTypesCard } from "@memorang/ui/components/SkillProgressCards/ItemTypesCard";
import { useLocalSearchParams } from "expo-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const ItemTypesDetailContainer = () => {
	const { skillId } = useLocalSearchParams<{ skillId: string }>();
	const { sections, isLoading } = useLanguageLearningProgress();
	const { t } = useTranslation();
	const [detailQuestionTypeId, setDetailQuestionTypeId] = useState<string>();
	const {
		startAdaptiveSession,
		isCreatingAdaptiveSession,
		showMicPermissionDialog,
		setShowMicPermissionDialog,
	} = useAdaptiveSessionStart();

	const section = sections.find((candidate) => candidate.id === skillId);

	const navigateBack = () => handleNavigateBack("/(protected)/(tabs)/progress");

	if (!section) {
		return (
			<>
				<CustomAppBar
					title={t("progress.languageLearning.itemTypesFallbackTitle")}
					onPressBack={navigateBack}
					hideCommandBar
				/>
				{isLoading ? null : (
					<EmptyState
						title={t("progress.languageLearning.itemTypesEmptyTitle")}
						subtitle={t("progress.languageLearning.itemTypesEmptySubtitle")}
						cta={t("progress.languageLearning.itemTypesEmptyCta")}
						handleAction={navigateBack}
					/>
				)}
			</>
		);
	}

	const title = t("progress.languageLearning.itemTypesCardTitle", {
		skill: section.title,
	});

	return (
		<>
			<CustomAppBar title={title} onPressBack={navigateBack} hideCommandBar />
			<Box flex={1}>
				<ScrollContainer
					maxWidth="sm"
					contentContainerStyle={{
						padding: 16,
					}}
				>
					<ItemTypesCard
						title={title}
						subtitle={t("progress.languageLearning.itemTypesCardSubtitle", {
							count: section.itemTypeRows.length,
						})}
						icon={section.icon}
						rows={section.itemTypeRows}
						onViewDetails={setDetailQuestionTypeId}
					/>
				</ScrollContainer>
			</Box>
			<ItemTypeDetailModalContainer
				questionTypeId={detailQuestionTypeId}
				onClose={() => setDetailQuestionTypeId(undefined)}
				onStartRecommendedSession={startAdaptiveSession}
				starting={isCreatingAdaptiveSession}
			/>
			<MicrophonePermissionDialog
				showDialog={showMicPermissionDialog}
				setShowDialog={() => setShowMicPermissionDialog(false)}
			/>
		</>
	);
};

export default ItemTypesDetailContainer;
